class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.fakeFilterGroup = document.querySelector('#fake-sorting');
    this.realFilterGroup = document.querySelector('#real-sorting');
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.onSumbitFakeForm()
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');


    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
          FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
          FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }


  static renderSectionFromFetch(url, event) {
    fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {html, url}];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          const refreshEvent = new Event('refresh-card');
          document.dispatchEvent(refreshEvent);
        });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if (Trustpilot && document.querySelector('#product-grid .trustpilot-widget')) {
      document.querySelectorAll('#product-grid .trustpilot-widget').forEach(el => {
        (Trustpilot.loadFromElement(el), true);
      });
    }
    document.dispatchEvent(new CustomEvent('reloadLazyLoad'));
    document.querySelectorAll('#product-grid .grid__item-push video').forEach((video) => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
        parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '#test'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const newToggleWrapper = html.querySelector('.facets-toggle-wrapper');
    const currentToggleWrapper = document.querySelector('.facets-toggle-wrapper');
    if (newToggleWrapper && currentToggleWrapper) {
      currentToggleWrapper.replaceWith(newToggleWrapper.cloneNode(true));
    }

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({searchParams}, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    let urlSearchParamsObject = new URLSearchParams(formData)

    urlSearchParamsObject.delete('minfilterrange');
    urlSearchParamsObject.delete('maxfilterrange');

    const axFilterRanges = form.querySelectorAll('ax-filter-range');
    axFilterRanges.forEach((axFilterRange) => {
      const rangeMinEl = axFilterRange.querySelector('.range-min');
      const rangeMaxEl = axFilterRange.querySelector('.range-max');
      if (!rangeMinEl || !rangeMaxEl) return;

      const realInputName = axFilterRange.dataset.realName;
      const realInputValues = axFilterRange.dataset.values.split('|');
      const suffix = axFilterRange.dataset.suffix || '';
      const minVal = Number(rangeMinEl.value);
      const maxVal = Number(rangeMaxEl.value);
      const sliderMin = Number(rangeMinEl.min);
      const sliderMax = Number(rangeMaxEl.max);

      urlSearchParamsObject.delete(realInputName);

      if (minVal === sliderMin && maxVal === sliderMax) return;

      for (let i = minVal; i <= maxVal; i++) {
        const v = `${i}${suffix}`;
        if (realInputValues.includes(v)) urlSearchParamsObject.append(realInputName, v);
      }
    });

    return urlSearchParamsObject.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSumbitFakeForm() {
    this.fakeFilterGroup.querySelectorAll('.mobile-facets__item').forEach(fakeFilter => {
      fakeFilter.addEventListener('click', function (event) {
        if (!fakeFilter.classList.contains('selected')) {
          this.realFilterGroup.querySelector(`#${fakeFilter.id}`).parentNode.value = `${fakeFilter.id}`;

          const sortFilterForms = document.querySelectorAll('facet-filters-form form');
          const forms = [];

          sortFilterForms.forEach((form) => {
                forms.push(this.createSearchParams(form));
              }
          );

          this.fakeFilterGroup.querySelector('.selected')?.classList.remove('selected');
          fakeFilter.querySelector('.mobile-facets__checkbox').classList.add('selected');

          this.onSubmitForm(forms.join('&'), event)
        }
      }.bind(this))
    })
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'FacetToggleForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
        .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class axRange extends HTMLElement {
  constructor() {
    super();
    this.rangeInputs = this.querySelectorAll('input[type="range"]');
    this.numberInputs = this.querySelectorAll('.inputValues__input');
    this.range = this.querySelector(".slider-range .progress");
    this.realName = this.dataset.realName
    this.suffix = this.dataset.suffix || ''
    this.values = this.dataset.values.split('|')
    this.calculateProgress();
    this.rangeMove();
    this.numberInputMove();
  }

  preventOverlap() {
    const minR = this.rangeInputs[0];
    const maxR = this.rangeInputs[1];
    const minVal = parseInt(minR.value);
    const maxVal = parseInt(maxR.value);
    const sliderMin = parseInt(minR.min);
    const sliderMax = parseInt(maxR.max);
    if (minVal >= maxVal) {
      if (minVal < sliderMax) {
        maxR.value = minVal + 1;
      } else {
        minR.value = maxVal - 1;
      }
    }
    if (parseInt(minR.value) < sliderMin) minR.value = sliderMin;
    if (parseInt(maxR.value) > sliderMax) maxR.value = sliderMax;
    if (this.numberInputs[0]) this.numberInputs[0].value = minR.value;
    if (this.numberInputs[1]) this.numberInputs[1].value = maxR.value;
  }

  rangeMove() {
    this.rangeInputs.forEach((range, index) => {
      range.addEventListener('input', (e) => {
        e.stopImmediatePropagation();
        if (this.numberInputs[index]) this.numberInputs[index].value = range.value;
        this.preventOverlap();
        this.calculateProgress();
      })

      range.addEventListener('change', () => {
        this.applyFilter();
      })
    })
  }

  numberInputMove() {
    this.numberInputs.forEach((input, index) => {
      input.addEventListener('change', () => {
        let val = parseInt(input.value);
        const min = parseInt(this.rangeInputs[index].min);
        const max = parseInt(this.rangeInputs[index].max);
        if (isNaN(val)) val = index === 0 ? min : max;
        val = Math.max(min, Math.min(max, val));
        input.value = val;
        this.rangeInputs[index].value = val;
        this.preventOverlap();
        this.applyFilter();
      })
    })
  }

  applyFilter() {
    let urlFilter = window.location.search.slice(1);
    const escapedRealName = this.realName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    urlFilter = urlFilter.replace(new RegExp(`(^|&)${escapedRealName}=[^&]*`, 'g'), '');
    if (urlFilter.startsWith('&')) urlFilter = urlFilter.slice(1);

    for (let i = parseInt(this.rangeInputs[0].value); i < (parseInt(this.rangeInputs[1].value) + 1); i++) {
      const value = `${i}${this.suffix}`;
      if (this.values.includes(value)) {
        urlFilter += `${urlFilter.length ? '&' : ''}${this.realName}=${encodeURIComponent(value)}`;
      }
    }

    FacetFiltersForm.renderPage(urlFilter, null, true);
    this.calculateProgress();
  }

  calculateProgress() {
    let leftRangeValue = parseInt(this.rangeInputs[0].value),
        rightRangeValue = parseInt(this.rangeInputs[1].value),
        minRangePosition = leftRangeValue - parseInt(this.rangeInputs[0].min),
        maxRangePosition = parseInt(this.rangeInputs[1].max) - rightRangeValue,
        difference = this.rangeInputs[1].max - this.rangeInputs[0].min,
        posLeft = ((100 * minRangePosition) / difference) + '%',
        posRight = ((100 * maxRangePosition) / difference) + '%';

    this.range.style.left = posLeft;
    this.range.style.right = posRight;
  }
}

customElements.define('ax-filter-range', axRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsContainer extends HTMLElement {
  constructor() {
    super();
    this.facetsWrapper = null;
  }

  connectedCallback() {
    this.facetsWrapper = this.closest('.facets-wrapper');
    const details = this.querySelector('details.mobile-facets__disclosure');
    if (details && this.facetsWrapper) {
      details.addEventListener('toggle', () => {
        this.facetsWrapper.style.zIndex = details.open ? '100' : '';
      });
    }
  }
}

customElements.get('facets-container') || customElements.define('facets-container', FacetsContainer);

document.addEventListener('DOMContentLoaded', function() {
	const facetDetails = document.querySelectorAll('.mobile-facets__details');
	const allLists = document.querySelectorAll('.mobile-facets__list');
	
	function containsEpaisseur(detail) {
		const summary = detail.querySelector('summary');
		return summary && summary.textContent.toLowerCase().includes('paisseur');
	}

	// Si il n'y a qu'une seule liste, cacher tous les facetDetails
	if (allLists.length === 1) {
		facetDetails.forEach(function(detail) {
			if (!containsEpaisseur(detail)) {
				detail.style.display = 'none';
			}
		});
	} else {
		// Sinon, cacher seulement ceux avec des listes vides
		facetDetails.forEach(function(detail) {
			const list = detail.querySelector('.mobile-facets__list');
			if (list && (list.children.length === 0) && !containsEpaisseur(detail)) {
				detail.style.display = 'none';
			}
		});
	}

	// Cacher mobile-facets__summary parent si il n'y a qu'un seul <li>
	const facetSubmenu = document.querySelectorAll('.mobile-facets__submenu');
	facetSubmenu.forEach(function(submenu) {
		const list = submenu.querySelector('.mobile-facets__list');
		if (list) {
			const listItems = list.querySelectorAll('li');
			if (listItems.length === 1) {
				const details = submenu.closest('details');
				if (details && !containsEpaisseur(details)) {
					details.style.display = 'none';
				} else if (!details) {
					const summary = submenu.closest('.mobile-facets__summary');
					if (summary) {
						summary.style.display = 'none';
					}
				}
			}
		}
	});
});

// Custom sort dropdown
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sort-dropdown]').forEach(function (field) {
    var select = field.querySelector('.facets-sort-mobile__select');
    var dropdown = field.querySelector('.facets-sort-mobile__dropdown');
    if (!select || !dropdown) return;

    field.addEventListener('click', function (e) {
      if (e.target.closest('.facets-sort-mobile__dropdown')) return;
      field.classList.toggle('is-open');
    });

    dropdown.querySelectorAll('.facets-sort-mobile__option').forEach(function (option) {
      option.addEventListener('click', function () {
        select.value = option.getAttribute('data-value');
        select.dispatchEvent(new Event('input', { bubbles: true }));
        dropdown.querySelectorAll('.facets-sort-mobile__option').forEach(function (o) {
          o.classList.remove('is-active');
        });
        option.classList.add('is-active');
        field.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!field.contains(e.target)) {
        field.classList.remove('is-open');
      }
    });
  });
});